
interface InstagramPost {
  id: string;
  media_url: string;
  media_type?: string;
  caption?: string;
  permalink: string;
  timestamp: string;
  thumbnail_url?: string;
}

export interface FormattedInstagramPost {
  id: string;
  imageUrl: string;
  caption: string;
  likes: number;
  link: string;
  isReel: boolean;
}

// Image to use for the uploaded example
export const uploadedExampleImage = '/lovable-uploads/9dea227b-2922-43c6-8bc2-e9592e93b115.png';

// Instagram App ID and credentials
// App ID: 1653033436091998
// App Secret: 1b54db025e2ca9fbb03
// Updated access token
export const INSTAGRAM_TOKEN = 'IGAAXfbNbCll5BZAFkxcHJ0ZAEdPLTg5TnExcjR3ZAlkxSlFZARHhoOTE0cHVpU1pwMzJ3TzBMZAWcxR200YS1EZAG5VOW1LZA3NYWGd0SHQ0aWJFNlpCZA3FXYTJOQm9xcnV6T1g5YnJEd25CUFNMdVk5ZAjZAGUzJYejJmUHQ2RU1XaHlfbwZDZD';

// Fallback posts when API fails
export const fallbackPosts: FormattedInstagramPost[] = [
  {
    id: '1',
    imageUrl: '/lovable-uploads/1da4982d-cf51-443d-a53b-c88707f47a47.png',
    caption: 'Wspaniały wieczór z @jankowalski i @annakowalska. #portrait #photography',
    likes: 124,
    link: 'https://www.instagram.com/p/C2MjmozN2eG/',
    isReel: false
  },
  {
    id: '2',
    imageUrl: '/lovable-uploads/f042cc68-c11c-4bfa-9997-0bc0dd0af194.png',
    caption: 'Sesja w Parku Miejskim, pełna emocji. #photooftheday #portrait',
    likes: 87,
    link: 'https://www.instagram.com/p/C2MjmozN2eG/',
    isReel: false
  },
  {
    id: '3',
    imageUrl: '/lovable-uploads/22de1b96-c8ac-4016-b67f-9655b47d7a0a.png',
    caption: 'Wspomnienia, które pozostaną na zawsze. #familyphotography',
    likes: 245,
    link: 'https://www.instagram.com/p/C2MjmozN2eG/',
    isReel: true
  },
  {
    id: '4',
    imageUrl: '/lovable-uploads/f1c7fccc-df0a-462d-830a-ab9b597ed526.png',
    caption: 'Urodziny w stylu retro. #birthdayparty #photobooth',
    likes: 110,
    link: 'https://www.instagram.com/p/C2MjmozN2eG/',
    isReel: false
  },
  {
    id: '5',
    imageUrl: '/lovable-uploads/28ea1852-4e58-4daf-8b79-984f3d3b88ae.png',
    caption: 'Dzisiaj na kolejnym evencie biznesowym. #eventphoto #corporate',
    likes: 68,
    link: 'https://www.instagram.com/p/C2MjmozN2eG/',
    isReel: true
  },
  {
    id: '6',
    imageUrl: '/lovable-uploads/2cfc07fd-6e1c-48f5-b85a-0870b6be7d76.png',
    caption: 'Wesele Agnieszki i Marka - dziękujemy za zaufanie! #wedding #love',
    likes: 189,
    link: 'https://www.instagram.com/p/C2MjmozN2eG/',
    isReel: false
  }
];

export const fetchInstagramData = async (): Promise<FormattedInstagramPost[]> => {
  try {
    const response = await fetch(
      `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,timestamp,media_type,thumbnail_url&access_token=${INSTAGRAM_TOKEN}`
    );
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('Instagram API response:', errorData);
      
      // Check if token has expired
      if (errorData?.error?.code === 190) {
        throw new Error('token_expired');
      }
      
      throw new Error('Error fetching data from Instagram');
    }
    
    const data = await response.json();
    
    if (data && data.data && Array.isArray(data.data)) {
      const formattedPosts: FormattedInstagramPost[] = data.data
        .slice(0, 6)
        .map((post: InstagramPost) => {
          // Handle different media types (REEL vs IMAGE)
          const isReel = post.media_type === 'VIDEO';
          const imageUrl = isReel && post.thumbnail_url ? post.thumbnail_url : post.media_url;
          
          return {
            id: post.id,
            imageUrl: imageUrl || uploadedExampleImage,
            caption: post.caption || 'Czułe Klisze #fotografia',
            likes: Math.floor(Math.random() * 200) + 50,
            link: post.permalink,
            isReel: isReel
          };
        });
      
      return formattedPosts;
    }
    
    throw new Error('Invalid response from Instagram API');
  } catch (error) {
    if ((error as Error).message === 'token_expired') {
      throw error;
    }
    console.error('Error fetching Instagram data:', error);
    throw error;
  }
};

// Create a fallback version with example image
export const getFallbackPosts = (): FormattedInstagramPost[] => {
  const updatedFallbackPosts = [...fallbackPosts];
  // Update at least one post to use the uploaded example image
  updatedFallbackPosts[2] = {
    ...updatedFallbackPosts[2],
    imageUrl: uploadedExampleImage,
    isReel: true
  };
  
  return updatedFallbackPosts;
};
